module.exports = __webpack_public_path__ + "img/as.27f3e372.svg";